import { getStartedStore } from '../store/store';
export function getAllGetStartedTasksNumber() {
    var store = getStartedStore();
    if (store.tasks) {
        return store.tasks.length;
    }
    return null;
}
//# sourceMappingURL=getAllGetStartedTasksNumber.js.map